type PreviewInfoTextProps = {
  label?: string;
  description?: string;
};

const PreviewInfoText = ({ label, description }: PreviewInfoTextProps): React.ReactElement | null => {
  if (!label && !description) return null;

  return (
    <div className="pr-8">
      {!!label && <p className="body-sm text-neutral-600">{label}</p>}
      {!!description && <p className="body-base text-neutral-900">{description}</p>}
    </div>
  );
};

export default PreviewInfoText;
